import { useEffect, useCallback } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import {
    RPM_CREATE_CPT_LOG_BEGIN,
    RPM_CREATE_CPT_LOG_SUCCESS,
    RPM_CREATE_CPT_LOG_FAILURE,
    RPM_CREATE_CPT_LOG_DISMISS_ERROR,
} from './constants'
import config from '../../../common/config'
import axios from 'axios'
import { createAxiosConfigWithAuth } from '../../../common/apiHelpers'

export function createCptLog(args = {}) {
    return (dispatch, getState) => {
        // optionally you can have getState as the second argument
        dispatch({
            type: RPM_CREATE_CPT_LOG_BEGIN,
        })

        const promise = new Promise((resolve, reject) => {
            const doRequest = axios.post(
                config.apiRootUrl + '/rpm/cpt-log/',
                args,
                createAxiosConfigWithAuth(getState())
            )
            doRequest.then(
                res => {
                    dispatch({
                        type: RPM_CREATE_CPT_LOG_SUCCESS,
                        data: res,
                    })
                    resolve(res)
                },
                // Use rejectHandler as the second argument so that render errors won't be caught.
                err => {
                    dispatch({
                        type: RPM_CREATE_CPT_LOG_FAILURE,
                        data: { error: err },
                    })
                    reject(err)
                }
            )
        })

        return promise
    }
}

export function dismissCreateCptLogError() {
    return {
        type: RPM_CREATE_CPT_LOG_DISMISS_ERROR,
    }
}

export function useCreateCptLog() {
    const dispatch = useDispatch()

    const { createCptLogPending, createCptLogError } = useSelector(
        state => ({
            createCptLogPending: state.rpm.createCptLogPending,
            createCptLogError: state.rpm.createCptLogError,
        }),
        shallowEqual
    )

    const boundAction = useCallback(
        (...args) => {
            return dispatch(createCptLog(...args))
        },
        [dispatch]
    )

    const boundDismissError = useCallback(() => {
        return dispatch(dismissCreateCptLogError())
    }, [dispatch])

    return {
        createCptLog: boundAction,
        createCptLogPending,
        createCptLogError,
        dismissCreateCptLogError: boundDismissError,
    }
}

export function reducer(state, action) {
    switch (action.type) {
        case RPM_CREATE_CPT_LOG_BEGIN:
            // Just after a request is sent
            return {
                ...state,
                createCptLogPending: true,
                createCptLogError: null,
            }

        case RPM_CREATE_CPT_LOG_SUCCESS:
            // The request is success
            return {
                ...state,
                createCptLogPending: false,
                createCptLogError: null,
            }

        case RPM_CREATE_CPT_LOG_FAILURE:
            // The request is failed
            return {
                ...state,
                createCptLogPending: false,
                createCptLogError: action.data.error,
            }

        case RPM_CREATE_CPT_LOG_DISMISS_ERROR:
            // Dismiss the request failure error
            return {
                ...state,
                createCptLogError: null,
            }

        default:
            return state
    }
}
